module.exports = __webpack_public_path__ + "img/dices-bottom-right.601354b5.svg";